import { render } from "./CheckListAcessoView.vue?vue&type=template&id=94953dc2&scoped=true"
import script from "./CheckListAcessoView.vue?vue&type=script&lang=js"
export * from "./CheckListAcessoView.vue?vue&type=script&lang=js"

import "./CheckListAcessoView.vue?vue&type=style&index=0&id=94953dc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94953dc2"]])

export default __exports__